import React from 'react'
import { useUserStore } from 'Stores/userStoreModuleFed'

export const VisibleOnlyToOwner = ({
  children,
  allowAdmin = false,
}: {
  children: React.ReactNode
  allowAdmin?: boolean
}) => {
  const { owner, isAdmin } = useUserStore()
  return <>{(owner || (allowAdmin && isAdmin)) && children}</>
}
